export default __webpack_public_path__ + "static/media/40.7c913be3.jpg";